import { __rest, __assign } from 'tslib';
import React__default, { useEffect } from 'react';
import clsx from 'clsx';
import { propTypes, defaultProps } from './Sidebar.types.js';
import { Page } from './Page.component.js';
import { Layout } from './Layout.component.js';
import styles from './Sidebar.module.scss.js';

var Sidebar = function (props) {
    var isOpen = props.isOpen, onTransitionEnd = props.onTransitionEnd, className = props.className, position = props.position, hasBackgroundBlur = props.hasBackgroundBlur, overlayClassName = props.overlayClassName, testId = props["data-testid"], restProps = __rest(props, ["isOpen", "onTransitionEnd", "className", "position", "hasBackgroundBlur", "overlayClassName", 'data-testid']);
    useEffect(function () {
        if (isOpen) {
            document.body.classList.add(styles.Body___noScroll);
        }
        else {
            document.body.classList.remove(styles.Body___noScroll);
        }
        return function () {
            document.body.classList.remove(styles.Body___noScroll);
        };
    }, [isOpen]);
    var overlayClass = clsx(styles.Overlay, isOpen && styles.Overlay___opened, hasBackgroundBlur && styles.Overlay___blurred, overlayClassName);
    var sidebarClass = clsx(className, styles.Sidebar, styles["Sidebar___".concat(position)], isOpen && styles.Sidebar___open);
    var handleOnTransitionEnd = function (e) {
        if (onTransitionEnd && e.propertyName === 'transform') {
            onTransitionEnd(isOpen);
        }
    };
    return (React__default.createElement("div", { "data-testid": testId, onTransitionEnd: handleOnTransitionEnd, className: overlayClass },
        React__default.createElement(Layout, __assign({ handleOnTransitionEnd: handleOnTransitionEnd, className: sidebarClass, headerClassName: styles.Sidebar_header, bodyClassName: styles.Sidebar_body, footerClassName: styles.Sidebar_footer }, restProps))));
};
Sidebar.propTypes = propTypes;
Sidebar.defaultProps = defaultProps;
Sidebar.displayName = 'Sidebar';
Sidebar.Page = Page;

export { Sidebar, Sidebar as default };
